import React from 'react';
import { i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import controlIds from '../constants/control-ids';
import previewGifs from '../constants/preview-gifs';
import attributes from '../constants/attributes';
import computeCornersFallback from '../helpers/compute-corners-fallback';

const { Paragraph, Icon } = designSystem;

const SLIDER_MIN = 0;
const SLIDER_MAX = 128;
const SLIDER_STEP = 1;

const CORNERS = {
  topLeft: {
    id: 'top-left-corner',
    attributes: [attributes.BORDER_TOP_LEFT_RADIUS],
    iconGlyph: 'corner-top-left-radius',
  },
  topRight: {
    id: 'top-right-corner',
    attributes: [attributes.BORDER_TOP_RIGHT_RADIUS],
    iconGlyph: 'corner-top-right-radius',
  },
  bottomLeft: {
    id: 'bottom-left-corner',
    attributes: [attributes.BORDER_BOTTOM_LEFT_RADIUS],
    iconGlyph: 'corner-bottom-left-radius',
  },
  bottomRight: {
    id: 'bottom-right-corner',
    attributes: [attributes.BORDER_BOTTOM_RIGHT_RADIUS],
    iconGlyph: 'corner-bottom-right-radius',
  },
};

const getPopoverProps = ({ imgSrc, iconGlyph }) => ({
  imgSrc,
  renderContent: () => (
    <Paragraph appearance="white" size="small">
      {i18next.t('Adjust corners for columns')}. {i18next.t('Click the {icon}', { icon: '' })}{' '}
      <Icon type="white" size={16} strokeWidth={2} glyph={iconGlyph} insideText />
      {i18next.t('{click_the_icon} to adjust each one separately', { click_the_icon: '' })}
    </Paragraph>
  ),
});

const getCorners = (settingId, settings = {}) => ({
  ...settings,
  id: controlIds.CORNERS,
  title: i18next.t('Independent corners'),
  attributes: Object.values(CORNERS).flatMap(({ attributes: attrs }) => attrs),
  computeFallbackValue: computeCornersFallback,
  iconGlyph: 'corner-radius',
  mixedLabel: i18next.t('Mixed'),
  step: SLIDER_STEP,
  min: SLIDER_MIN,
  max: SLIDER_MAX,
  items: Object.values(CORNERS).map((item) => ({
    ...item,
    computeFallbackValue: computeCornersFallback,
  })),
  popover: getPopoverProps({
    imgSrc: previewGifs.COLUMN_CORNERS_GIF,
    iconGlyph: 'corner-radius',
  }),
});

export default getCorners;
